export default __webpack_public_path__ + "static/media/geospy.42620ff3.svg";